import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretUp } from '@fortawesome/pro-solid-svg-icons/faCaretUp';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import classnames from 'clsx';
import { components } from 'react-select';

import style from './dropdown-indicator.module.css';

const ReactSelectDropdownIndicator = components.DropdownIndicator;

/**
 * @typedef {import('react-select').DropdownIndicatorProps} DropdownIndicatorProps
 */

/**
 * @param {DropdownIndicatorProps} props
 * @returns {JSX.Element}
 */
export const DropdownIndicator = (props) => {
  const isOpen = props.selectProps?.menuIsOpen;
  const icon = isOpen ? faCaretUp : faCaretDown;

  return (
    <ReactSelectDropdownIndicator {...props}>
      <FontAwesomeIcon
        className={classnames(style['dropdown-indicator-icon'], {
          [style['is-open']]: isOpen,
        })}
        icon={icon}
      />
    </ReactSelectDropdownIndicator>
  );
};
